import { combineReducers } from "redux";

import person from "./person";
import search from "./search";
import editing from "./editing";
import persons from "./persons";
import addresses from "./addresses";

export default combineReducers({
  person: person.reducer,
  search: search.reducer,
  editing: editing.reducer,
  persons: persons.reducer,
  addresses: addresses.reducer,
});



// WEBPACK FOOTER //
// ./src/modules/rootReducer.js